import { useEffect, useRef } from 'react';

import { isNil, difference } from 'ramda';

type UseNavigateAfterCreate = (
  rows: unknown[] | undefined,
  afterCreateCb: (props: any) => void
) => void;

const useNavigateAfterCreate: UseNavigateAfterCreate = (
  rows,
  afterCreateCb
) => {
  const previousRows = useRef<any[] | undefined>(undefined);

  // this sets the initial rows that we need to keep track on
  useEffect(() => {
    if (previousRows.current === undefined) {
      previousRows.current = rows;
    }
  }, [rows]);

  useEffect(() => {
    if (!isNil(previousRows.current) && !isNil(rows)) {
      if (previousRows.current.length < rows.length) {
        const diffArray = difference(rows, [...previousRows.current]);
        afterCreateCb(diffArray[0]);
      }
    }

    previousRows.current = rows;
  }, [rows]);
};

export default useNavigateAfterCreate;
